import {
  REFRESHING_SESSION_TOKEN,
  refreshSessionToken,
} from "../reducers/currentUser";

import { checkIfErrorCodePresent } from "../utils/errorHandling";

// State Parsing

const refreshTokenExists = (state) => {
  return state.currentUser?.refreshToken;
};

// Action Parsing

const actionIsFailedRequest = (action) => {
  if (
    !actionIsRefreshAction(action) &&
    action.error &&
    action.meta.previousAction
  ) {
    return checkIfErrorCodePresent(action.error, "session_token_expired");
  }
};

const actionIsRefreshAction = (action) => {
  return action.types && action.types[0] === REFRESHING_SESSION_TOKEN;
};

// Event Triggers

const triggerRefresh = (dispatch, action, state, next) => {
  if (state.currentUser.isRefreshingTokenPromise) {
    return state.currentUser.isRefreshingTokenPromise;
  }

  return refreshSessionToken()(dispatch);
};

const resendInitialRequest = (dispatch, action) => {
  return dispatch(action.meta.previousAction);
};

// Exports

export const handleExpiredTokens = ({ dispatch, getState }) => {
  return (next) => (action) => {
    let state = getState();

    if (refreshTokenExists(state) && actionIsFailedRequest(action)) {
      let promise = triggerRefresh(dispatch, action, state, next);

      return promise.then(() => resendInitialRequest(dispatch, action));
    }

    return next(action);
  };
};
